import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const PROBLEMS = [{
  icon: '🥗',
  title: 'Quiero comer sano pero no sé por dónde empezar',
  text: 'Sabés que tenés que cambiar tu alimentación, pero terminás improvisando comidas, repitiendo siempre lo mismo o abandonando porque no sabés cómo organizarte.',
  color: 'border-combo-green'
}, {
  icon: '❤️',
  title: 'El médico me dijo que cambie la alimentación',
  text: 'Tenés colesterol alto, presión alta o necesitás bajar de peso, pero nadie te explicó exactamente qué cocinar todos los días.',
  color: 'border-combo-navy'
}, {
  icon: '💪',
  title: 'Entreno seguido pero mi alimentación no acompaña',
  text: 'Hacés ejercicio constantemente, pero sentís que tu nutrición no está a la altura del esfuerzo que hacés.',
  color: 'border-combo-burgundy'
}];
export function ProblemSection() {
  return <section className="py-24 bg-cream-dark" data-id="element-550">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-551">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-552">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-ink" data-id="element-553">
            ¿Cuál de estas situaciones es la tuya?
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-554">
          {PROBLEMS.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white rounded-2xl p-8 shadow-premium hover:shadow-premium-hover transition-all duration-300 hover:-translate-y-2 border-t-4 ${problem.color} flex flex-col h-full`} data-id="element-555">
              <div className="text-4xl mb-6" data-id="element-556">{problem.icon}</div>
              <h3 className="text-xl font-serif font-bold text-ink mb-4 leading-tight" data-id="element-557">
                {problem.title}
              </h3>
              <p className="text-ink-light leading-relaxed mb-8 flex-1" data-id="element-558">
                {problem.text}
              </p>
              {index === 0 && <a href="#kits" className="inline-flex items-center gap-2 text-sm font-bold text-ink hover:text-gold transition-colors mt-auto" data-id="element-559">
                  Este soy yo <ArrowRight className="w-4 h-4" data-id="element-560" />
                </a>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}